var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.classNames,attrs:{"href":_vm.link,"title":_vm.$t(_vm.platform),"data-button-code":_vm.buttonCode,"data-platform":_vm.platform,"data-adjust-platform":_vm.platform},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }